import React, { useEffect, useState } from "react";
import AddDashboardButton from "./components/Modals/AddDashboardButton";
import { useAppServices } from "../../../../hook/services";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

const DashboardButtons = () => {
  const AppService = useAppServices();
  const { companyId, type, customizationId } = useParams();
  const handler =
    type === "agency" || type === "location"
      ? AppService.sidenav_customizer_main_level
      : type === "group"
      ? AppService.sidenav_customizer_custom_level
      : AppService.sidenav_customizer_saas_level;

  const query =
    type === "location" || type === "agency"
      ? `companyId=${companyId}&type=${type}`
      : `_id=${customizationId}`;

  const [dashboardButtons, setDashboardButtons] = useState([]);
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(true);
  const [deletingIndex, setDeletingIndex] = useState(null);

  const getData = async () => {
    setLoader(true);
    try {
      const { response } = await handler.filter({ query });
      if (response?.data) {
        setDashboardButtons(response.data.dashboard_button || []);
        setData(response.data);
      } else {
        setDashboardButtons([]);
        setData({});
      }
    } catch (error) {
      console.error("Failed to fetch dashboard buttons:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = async (editIndex) => {
    if (editIndex === null || editIndex < 0 || !data?._id) {
      toast.error("Invalid delete request.");
      return;
    }

    const updatedButtons = [...(data.dashboard_button || [])];
    updatedButtons.splice(editIndex, 1);

    const payload = {
      dashboard_button: updatedButtons,
      companyId,
      _id: data._id,
    };

    try {
      setDeletingIndex(editIndex);
      const { response } = await handler.update({ payload });
      if (response) {
        toast.success("Button deleted.");
        getData();
      } else {
        toast.error("Failed to delete the button.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("An error occurred while deleting.");
    } finally {
      setDeletingIndex(null);
    }
  };

  return (
    <div className="db-list-wrapper">
      <style>{`
        .db-list-wrapper {
          background: #ffffff;
          border-radius: 16px;
          padding: 22px 24px;
          border: 1px solid #e2e8f0;
        }
        .db-list-header {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          gap: 16px;
          flex-wrap: wrap;
          margin-bottom: 20px;
        }
        .db-list-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .db-list-title .db-badge {
          background: #eef2ff;
          color: #4338ca;
          font-size: 12px;
          font-weight: 600;
          border-radius: 999px;
          padding: 2px 10px;
        }
        .db-list-subtitle {
          color: #64748b;
          font-size: 13px;
          margin: 4px 0 0;
        }
        .db-empty {
          border: 1px dashed #cbd5e1;
          border-radius: 14px;
          padding: 48px 20px;
          text-align: center;
          background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
        }
        .db-empty .db-empty-icon {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          background: #fff;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          color: #4f46e5;
          font-size: 26px;
          box-shadow: 0 8px 24px rgba(79, 70, 229, 0.18);
          margin-bottom: 14px;
        }
        .db-empty h6 {
          font-size: 15px;
          color: #0f172a;
          font-weight: 600;
          margin: 0 0 4px;
        }
        .db-empty p {
          color: #64748b;
          font-size: 13px;
          margin: 0 0 14px;
        }
        .db-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 14px;
        }
        .db-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 12px;
          transition: border-color 0.15s, box-shadow 0.15s, transform 0.15s;
        }
        .db-card:hover {
          border-color: #c7d2fe;
          box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
        }
        .db-card-preview {
          background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
          border-radius: 10px;
          padding: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .db-card-btn {
          border: none;
          border-radius: 8px;
          padding: 8px 16px;
          font-weight: 500;
          font-size: 13px;
          color: #fff;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          box-shadow: 0 4px 12px rgba(15, 23, 42, 0.15);
          cursor: default;
        }
        .db-card-meta {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .db-card-meta .db-card-name {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          margin: 0;
          word-break: break-word;
        }
        .db-card-meta .db-card-action {
          font-size: 12px;
          color: #64748b;
          display: flex;
          align-items: center;
          gap: 6px;
          word-break: break-all;
        }
        .db-card-meta .db-card-action > span.text-truncate {
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .db-card-meta .db-action-pill {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          background: #f1f5f9;
          color: #334155;
          font-size: 11px;
          padding: 2px 8px;
          border-radius: 999px;
          font-weight: 500;
          flex-shrink: 0;
        }
        .db-card-meta .db-action-pill.target { background: #eef2ff; color: #4338ca; }
        .db-card-meta .db-action-pill.link { background: #ecfeff; color: #0e7490; }
        .db-card-actions {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 4px;
          padding-top: 12px;
          border-top: 1px solid #f1f5f9;
        }
        .db-card-actions .db-action-btn {
          flex: 1;
          border: 1px solid #e2e8f0;
          background: #fff;
          color: #475569;
          border-radius: 8px;
          padding: 6px 10px;
          font-size: 12px;
          font-weight: 500;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          transition: all 0.15s;
        }
        .db-card-actions .db-action-btn:hover {
          background: #f8fafc;
          color: #0f172a;
        }
        .db-card-actions .db-action-btn.delete {
          color: #b91c1c;
          border-color: #fecaca;
          background: #fef2f2;
        }
        .db-card-actions .db-action-btn.delete:hover {
          background: #fee2e2;
          color: #991b1b;
        }
        .db-card-actions .db-edit-slot { flex: 1; display: flex; }
        .db-card-actions .db-edit-slot > * { width: 100%; }
        .db-card-actions .db-edit-slot .btn {
          width: 100%;
          padding: 6px 10px;
          font-size: 12px;
          font-weight: 500;
          gap: 6px;
        }
        .db-skeleton {
          height: 180px;
          border-radius: 14px;
          background: linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%);
          background-size: 200% 100%;
          animation: dbSkeleton 1.5s ease-in-out infinite;
        }
        @keyframes dbSkeleton {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>

      <div className="db-list-header">
        <div>
          <h3 className="db-list-title">
            <i className="bi bi-grid-1x2-fill text-primary" />
            Dashboard Buttons
            {!loader && (
              <span className="db-badge">{dashboardButtons.length}</span>
            )}
          </h3>
          <p className="db-list-subtitle">
            Quick-access buttons that appear on the GHL dashboard.
          </p>
        </div>
        {!loader && <AddDashboardButton data={data} handleRefresh={getData} />}
      </div>

      {loader ? (
        <div className="db-grid">
          <div className="db-skeleton" />
          <div className="db-skeleton" />
          <div className="db-skeleton" />
        </div>
      ) : dashboardButtons.length === 0 ? (
        <div className="db-empty">
          <div className="db-empty-icon">
            <i className="bi bi-grid-1x2" />
          </div>
          <h6>No dashboard buttons yet</h6>
          <p>
            Add your first button to give users a fast shortcut from the GHL
            dashboard.
          </p>
          <AddDashboardButton data={data} handleRefresh={getData} />
        </div>
      ) : (
        <div className="db-grid">
          {dashboardButtons.map((item, index) => {
            const isLink = item.type === "LINK";
            const isCustomTarget = item.type === "TARGET" && !!item.linkTarget;
            return (
              <div className="db-card" key={index}>
                <div className="db-card-preview">
                  <span
                    className="db-card-btn"
                    style={{ background: item.color || "#4f46e5" }}
                  >
                    {item.icon && (
                      <i
                        className={`${item.iconFamily || "fas"} fa-${item.icon}`}
                        style={{ fontSize: 13 }}
                      />
                    )}
                    <span>{item.text}</span>
                  </span>
                </div>

                <div className="db-card-meta">
                  <p className="db-card-name" title={item.text}>
                    {item.text}
                  </p>
                  {isLink && (
                    <div className="db-card-action">
                      <span className="db-action-pill link">
                        <i className="bi bi-link-45deg" />
                        Link
                      </span>
                      <span className="text-truncate" title={item.link}>
                        {item.link}
                      </span>
                    </div>
                  )}
                  {item.type === "TARGET" && !isCustomTarget && (
                    <div className="db-card-action">
                      <span className="db-action-pill target">
                        <i className="bi bi-bullseye" />
                        Target
                      </span>
                      <span
                        className="text-truncate"
                        title={item.targetLocation}
                      >
                        {item.targetLocation}
                      </span>
                    </div>
                  )}
                  {isCustomTarget && (
                    <div className="db-card-action">
                      <span className="db-action-pill link">
                        <i className="bi bi-link-45deg" />
                        Custom URL
                      </span>
                      <span className="text-truncate" title={item.linkTarget}>
                        {item.linkTarget}
                      </span>
                    </div>
                  )}
                </div>

                <div className="db-card-actions">
                  <div className="db-edit-slot">
                    <AddDashboardButton
                      data={data}
                      handleRefresh={getData}
                      selectedButton={item}
                      editIndex={index}
                    />
                  </div>
                  <button
                    className="db-action-btn delete"
                    title="Delete"
                    onClick={() => handleDelete(index)}
                    disabled={deletingIndex === index}
                  >
                    {deletingIndex === index ? (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      <>
                        <i className="bi bi-trash" />
                        Delete
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DashboardButtons;
